module.exports = __webpack_public_path__ + "fonts/D-DIN-Bold.c352e7b6.otf";